export const services = {
    login: '/rest/infra/sts', // sso登录-业务系统登录
    logout: '/rest/infra/n/logout?sid={sid}&followUrl={redirect}',
    userRole: '/rest/op/vc/merchant/shopMember/userRole', // 判断是店铺还是买家或者店铺授权员工、获取用户名称
    userRoleV2: '/rest/op/vc/merchant/shopMember/userRoleV2',
    distributePay: '/rest/op/vc/merchant/pay/binding/state', // 分销者支付进件状态
    distributePayStatus: '/league/rest/distribute/pay/status', // 分销者支付进件状态校验白名单
    limitedMemberRole: '/rest/op/vc/merchant/shopMember/limitedMemberRole', // 针对汽车店铺限制被授权账号权限
    merchantPay: '/rest/op/vc/merchant/pay', // 获取商家支付进件状态
    checkQRTemplate: '/rest/tp/seller/order/get/excel/template',
    preBatchConsume: '/rest/tp/seller/order/preBatchConsume',
    imageUpload: '/rest/op/vc/item/seller/item/pc/uploadFile',
    getCurrentAllRoles: '/rest/op/vc/merchant/userRoleManage/getCurrentAllRoles',
    queryPageChildrenUserByCondition: '/rest/op/vc/merchant/userRoleManage/queryPageChildrenUserByCondition',
    loginRole: '/rest/lbs/merchant/role/loginRole',

    getRelMerchantStatus: '/rest/merchant/home/getRelMerchantStatus', // 废弃 查询当前用户关联商家的入驻状态以及引导

    getMerchantInfo: '/rest/merchant/account/queryMerchantBySessionCode', // 通过sessionCode获取商家信息
    getAccountList: '/rest/merchant/account/queryAccountList', // 查询登录用户关联商家信息
    getUserResources: '/rest/merchant/auth/getUserResources?platform=1', // 获取用户含有权限的资源

    getOpeningResult: '/rest/pc/cs/b/common/getOpeningResult',  // 获取客服白名单接口
    getFaqUrl: '/rest/merchant/apicenter/customer/getUrl', // 获取客服中心的url
};
